export const MORE_LESS_CONTENT = [
  ['More yes', 'less no'],
  ['More speed', 'less waiting'],
  ['More loyalty', 'less cheating'],
  ['More savings', 'less fees'],
  ['More tech', 'less paper'],
  ['More humans', 'less bots'],
] as const;
